import SendIcon from "@mui/icons-material/Send";
import ReportIcon from "@mui/icons-material/Report";
import BlockIcon from "@mui/icons-material/Block";
import DeleteIcon from "@mui/icons-material/Delete";
import useStyles from "./style";
import { useDispatch, useSelector } from "react-redux";
import { profileActions } from "../../store/slices/profileSlice";


import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import SaveIcon from '@mui/icons-material/Save';
import ShareIcon from '@mui/icons-material/Share';
import React from "react";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import ConfirmationDialog from "../confirm-dialog";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { useLocalState } from "../../hooks";
import { useNavigate } from "react-router-dom";
import Api from "../../store/api";
import { showToast } from "../../utils/toast";

const actions = [
  { icon: <SendIcon />, name: 'Send Interest' },
  { icon: <ReportIcon />, name: 'Report This User' },
  { icon: <SaveIcon />, name: 'Add In MyBook' },
  { icon: <BlockIcon />, name: 'Block This User' },
  { icon: <ShareIcon />, name: 'Share This User' },
];

const REPORT_OPTIONS = [
  { label: 'Married', value: 'MARRIED' },
  { label: 'Fake', value: 'FAKE' },
  { label: 'Non Responsive', value: 'NON_RESPONSIVE' },
];

export default function Actions() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authUser = useSelector((state: any) => state.auth?.user);
  const classes = useStyles();

  const [LS, setLS] = useLocalState({
    dialogOpen: false,
    actionName: '',
    message: '',
    reportDialogOpen: false,
    reportReason: '',
    isSubmittingReport: false,
    reportError: '',
    isSubmitting: false,
  })

  const openReportDialog = async () => {
    const selectedProfile = sessionStorage.getItem('selectedProfile');
    if (!selectedProfile || !authUser?.id) return;
    const user = JSON.parse(selectedProfile);
    try {
      const response = await Api.getInterest(authUser.id, user.id);
      const interest = response?.data?.data;
      setLS({ reportDialogOpen: true, reportReason: interest?.report || '', reportError: '' });
    } catch (error) {
      setLS({ reportDialogOpen: true, reportReason: '', reportError: '' });
    }
  };

  const handleAction = async (actionName: string) => {
    if (actionName === 'Report This User') {
      openReportDialog();
      return;
    }

    // For Send/Cancel Interest, check current status
    if (actionName === 'Send Interest' || actionName === 'Cancel Interest') {
      const selectedProfile = sessionStorage.getItem('selectedProfile');
      if (selectedProfile) {
        const user = JSON.parse(selectedProfile);
        try {
          const response = await Api.getInterest(authUser.id, user.id);
          const interest = response?.data?.data;
          
          // If interest exists and is SENT or VIEWED, show "Cancel Interest"
          if (interest && (interest.state === 'SENT' || interest.state === 'VIEWED')) {
            const message = 'Do you want to cancel this interest?';
            setLS({ actionName: 'Cancel Interest', dialogOpen: true, message });
            return;
          }
          // Otherwise show "Send Interest"
          if (!interest || !interest.state || interest.state === 'REJECTED') {
            const message = 'Are You Sure To Send Interest?';
            setLS({ actionName: 'Send Interest', dialogOpen: true, message });
            return;
          }

          if (interest.state === 'ACCEPTED') {
            showToast('Interest already accepted.', 'warning');
            return;
          }

          if (interest.state === 'BLOCKED') {
            showToast('You cannot send interest to this profile because it is blocked.', 'warning');
            return;
          }

          if (interest.state === 'REPORTED') {
            showToast('You have already reported this profile.', 'warning');
            return;
          }

          showToast(`Current interest status: ${interest.state}`, 'info');
          return;
        } catch (error) {
          console.log('Error checking interest:', error);
          showToast('Unable to check current interest status. Please try again.', 'error');
          return;
        }
      }
      return;
    }

    const message = `Are You Sure To ${actionName}?`
    setLS({ actionName, dialogOpen: true, message })
  }

  const onConfrim = async () => {
    const selectedProfile = sessionStorage.getItem('selectedProfile');
    if (selectedProfile && LS.actionName === 'Send Interest') {
      const user = JSON.parse(selectedProfile);
      if (user.isInterestSent) return showToast('Already Interest Sent', 'warning');
      setLS({ isSubmitting: true });
      try {
        await Api.sendInterest(user.id);
        setLS({ isSubmitting: false, dialogOpen: false });
        showToast('Interest sent successfully', 'success');
        navigate('/user/sent-interests');
      } catch (error: any) {
        setLS({ isSubmitting: false });
        showToast(error?.response?.data?.message || 'Failed to send interest', 'error');
      }
      return;
    }

    if (selectedProfile && LS.actionName === 'Cancel Interest') {
      const user = JSON.parse(selectedProfile);
      setLS({ isSubmitting: true });
      try {
        await Api.cancelInterest(authUser.id, user.id);
        setLS({ isSubmitting: false, dialogOpen: false });
        showToast('Interest canceled', 'success');
        navigate('/user/sent-interests');
      } catch (error: any) {
        setLS({ isSubmitting: false });
        showToast(error?.response?.data?.message || 'Failed to cancel interest', 'error');
      }
      return;
    }
    
    if (selectedProfile && LS.actionName === 'Add In MyBook') {
      const user = JSON.parse(selectedProfile);
      setLS({ isSubmitting: true });
      try {
        await Api.addToMyBook(authUser.id, user.id, '');
        setLS({ isSubmitting: false, dialogOpen: false });
        showToast('Added to My Book', 'success');
      } catch (error: any) {
        setLS({ isSubmitting: false });
        showToast(error?.response?.data?.message || 'Failed to add to My Book', 'error');
      }
      return;
    }

    if (selectedProfile && LS.actionName === 'Block This User') {
      const user = JSON.parse(selectedProfile);
      setLS({ isSubmitting: true });
      try {
        await Api.updateInterestState(authUser.id, user.id, 'BLOCKED');
        setLS({ isSubmitting: false, dialogOpen: false });
        showToast('User blocked successfully', 'success');
      } catch (error: any) {
        setLS({ isSubmitting: false });
        showToast(error?.response?.data?.message || 'Failed to block user', 'error');
      }
    }
  }

  const handleReportSubmit = async () => {
    const selectedProfile = sessionStorage.getItem('selectedProfile');
    if (!selectedProfile || !authUser?.id) return;
    if (!LS.reportReason) {
      setLS({ reportError: 'Please select a report reason.' });
      return;
    }

    const user = JSON.parse(selectedProfile);
    setLS({ isSubmittingReport: true, reportError: '' });
    try {
      await Api.sendReportOrNote('REPORT', {
        fromId: authUser.id,
        toId: user.id,
        report: LS.reportReason,
      });
      setLS({ reportDialogOpen: false, isSubmittingReport: false });
      showToast('Report submitted successfully', 'success');
    } catch (error: any) {
      const reportError = error?.response?.data?.message || error?.message || 'Failed to submit report.';
      setLS({ isSubmittingReport: false, reportError });
    }
  };

  return (
    <React.Fragment>
      <SpeedDial
        ariaLabel="SpeedDial basic example"
        className={classes.action}
        icon={<SpeedDialIcon />}
      >
        {actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            onClick={() => handleAction(action.name)}
          />
        ))}
      </SpeedDial>
      <ConfirmationDialog
        open={LS.dialogOpen}
        onConfirm={onConfrim}
        onClose={() => setLS({ dialogOpen: false })}
        message={LS.message}
        title={LS.actionName.toUpperCase()}
        isLoading={LS.isSubmitting}
        confirmColor={LS.actionName === 'Block This User' ? 'error' : 'primary'}
      />
      <Dialog
        open={LS.reportDialogOpen}
        onClose={() => setLS({ reportDialogOpen: false, reportError: '' })}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>Report US</DialogTitle>
        <DialogContent>
          <FormControl sx={{ mt: 1, width: '100%' }}>
            <RadioGroup
              value={LS.reportReason}
              onChange={(event) => setLS({ reportReason: event.target.value, reportError: '' })}
            >
              {REPORT_OPTIONS.map((option) => (
                <FormControlLabel key={option.value} value={option.value} control={<Radio />} label={option.label} />
              ))}
            </RadioGroup>
          </FormControl>
          {LS.reportError && <Alert severity="error">{LS.reportError}</Alert>}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setLS({ reportDialogOpen: false, reportError: '' })} disabled={LS.isSubmittingReport}>Cancel</Button>
          <Button onClick={handleReportSubmit} variant="contained" disabled={LS.isSubmittingReport}>
            {LS.isSubmittingReport ? 'Submitting...' : 'Submit Report'}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}
